var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm._.checkbox,attrs:{"src":_vm.checked
      ? require('./images/复选框选中.png')
      : require('./images/复选框.png')},on:{"click":function (e) { return _vm.$emit('click', e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }